import { Typography } from '@mui/material/styles/createTypography';

export default <Typography>{};
